const product = {
  namespaced: true,
  state () {
    return {
      productId: null,
      projectId: null
    }
  },
  mutations: {
    setProductId (state, val) {
      state.productId = val
    },
    setProjectId (state, val) {
      state.projectId = val
    }
  },
  actions: {
  },
  getters: {
    getProductId (state) {
      return state.productId
    },
    getProjectId (state) {
      return state.projectId
    }
  }
}
export default product



// WEBPACK FOOTER //
// ./src/store/module/product.js